import React, { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import * as Constants from "../../../constants/Constants";
import "./style.css";

const ConfirmationModal = ({
  show,
  onOk,
  okButtonText,
  onCancel,
  onDeny,
  cancelButtonText,
  onError,
  confirmationText,
  confirmationTitle,
  onActionInProgress,
  forApproveDeny,
  cancelNotRequired,
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      contentClassName="denyModal"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {confirmationTitle ? confirmationTitle : "Please confirm"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="confirmationModal_bodyText">
          {confirmationText
            ? confirmationText
            : "Are you sure you want to perform this action ?"}
        </p>
        {onError && <p className="confirmationModal_bodyError">{onError}</p>}
      </Modal.Body>
      <Modal.Footer>
        {forApproveDeny === true ? (
          <div className="confirmationModal_footerButtonContainer">
            <Button
              variant="primary"
              className="button-primary-md"
              style={{ marginRight: 20 }}
              onClick={onOk}
              disabled={onActionInProgress}
            >
              {okButtonText ? okButtonText : Constants.BUTTON_OK}
            </Button>
           {(cancelNotRequired === undefined && <Button
              variant="primary"
              className="button-primary-md"
              onClick={onDeny}
              disabled={onActionInProgress}
            >
              {cancelButtonText ? cancelButtonText : Constants.BUTTON_CANCEL}
            </Button>)}
          </div>
        ) : (
          <div className="confirmationModal_footerButtonContainer">
            <Button
              variant="primary"
              className="button-secondary-md"
              style={{ marginRight: 20 }}
              onClick={onCancel}
              disabled={onActionInProgress}
            >
              {cancelButtonText ? cancelButtonText : Constants.BUTTON_CANCEL}
            </Button>
            <Button
              variant="primary"
              className="button-primary-md"
              onClick={onOk}
              disabled={onActionInProgress}
            >
              {okButtonText ? okButtonText : Constants.BUTTON_OK}
            </Button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
